import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './styles/bootstrap-custom.scss';
import './index.css';

const App = lazy(() => import('./App'));
const Home = lazy(() => import('./components/pages/home/Home.jsx'));
const ErrorPage = lazy(() => import('./components/pages/error/Error.jsx'));
const Capabilities = lazy(() => import('./components/pages/capabilities/Capabilities.jsx'));

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '*',
        element: <ErrorPage />
      },
      {
        path: '/capabilities',
        element: <Capabilities />
      }
    ]
  }
]);

const loadFonts = () => {
  import('@fontsource/titillium-web/400.css');
  import('@fontsource/titillium-web/600.css');
  import('@fontsource/titillium-web/700.css');
};

if (typeof window !== 'undefined') {
  let fontsRequested = false;
  const requestFonts = () => {
    if (fontsRequested) {
      return;
    }
    fontsRequested = true;
    loadFonts();
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(requestFonts, { timeout: 2000 });
  } else {
    window.addEventListener('load', () => {
      window.setTimeout(requestFonts, 0);
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div className="page-loader" aria-live="polite">Loading...</div>}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>
);
